// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__j_m_v","featured":"header_featured__OUUrI","comments":"header_comments__404_4"};